/* eslint-disable jsx-a11y/no-autofocus */
import React from "react";
import { createPortal } from "react-dom";
import { FocusOn } from "react-focus-on";
import { Wrapper, Content, Container, Headline } from "./styled";

interface Props {
  children: React.ReactNode;
  isOpen: boolean;
  title: string;
}

const Dialog: React.FC<Props> = ({ children, isOpen, title }) => {
  return createPortal(
    <div id="dialog-root">
      {isOpen && (
        <Wrapper role="alert">
          <FocusOn autoFocus={false}>
            <Container>
              <Headline>
                <h3>{title}</h3>
              </Headline>
              <Content aria-live="assertive">{children}</Content>
            </Container>
          </FocusOn>
        </Wrapper>
      )}
    </div>,
    document.body,
  );
};

export default Dialog;
